import { Component } from '@angular/core';

@Component({
  selector: 'app-loader',
  template: `<app-lottie-loader [height]="'75px'" [color]="'BLACK'"></app-lottie-loader>`,
})
export class LoaderComponent {}
